import React from 'react';
import { Stack } from '@fluentui/react';
import {
    SreHealthDetail,
    SreInflightItem,
} from '../../../../../AGSS/models/SreHealth';
import { SreFact } from './SreFact';
import { formatDateTime } from './formatting';

export const SreOrchestrationFacts: React.FC<{
    detail: SreHealthDetail;
    item?: SreInflightItem;
    orchestrationType?: string;
    icmId?: number;
}> = ({ detail, item, orchestrationType, icmId }) => (
    <Stack tokens={{ childrenGap: 6 }}>
        <SreFact label="Row ID" value={detail.id} />
        {(orchestrationType || item?.orchestrationType) && (
            <SreFact
                label="Plan"
                value={orchestrationType ?? item?.orchestrationType}
            />
        )}
        {icmId ?? item?.icmId ? (
            <SreFact label="IcM" value={icmId ?? item?.icmId} />
        ) : null}
        <SreFact label="Written" value={formatDateTime(detail.writtenTime)} />
        <SreFact
            label="Last modified"
            value={formatDateTime(detail.lastModifiedTime)}
        />
        {'pipeline' in detail && (
            <SreFact label="Pipeline" value={detail.pipeline} />
        )}
        {'region' in detail && <SreFact label="Region" value={detail.region} />}
        {'deploymentType' in detail && (
            <SreFact label="Deployment type" value={detail.deploymentType} />
        )}
        {detail.stagedInLowshare && (
            <SreFact
                label="Staged in lowshare"
                value={formatDateTime(detail.stagedInLowshare)}
            />
        )}
        <SreFact label="Latest completed" value={detail.latestCompletedStage} />
    </Stack>
);
